import React from 'react';


import "./Medailon.scss";
import { Img } from '../../../elements/Img/Img';
import { ImgStore } from '../../../elements/ImgStore/ImgStore';


export const Medailon = (props)=>{
    const { name, email, grant, onClick, picture, avatarVersion:av} = props;

    const base = `/store/user/me/avatar`;
    const img = av ? `${base}?v=${av}` : (picture || base);

    return (
        <div className="Medailon" title={`${name}\n${grant}\n${email}`} onClick={onClick}>
            <Img className="main" src={img} noFetch/>
            <ImgStore className="grant" src={`oauthGrant${String.jet.capitalize(grant)}.webp`}/>
        </div>
        
    )
}

